<div class="topWrapper">
  <taku-form-header
    [toolbarTitle]="'New Purchase Order'"
    displayMode="inline"
    [showActionBtns]="false"
    [showBackBtn]="false"
  >
    <button
      pButton
      class="p-button p-button-rounded"
      type="button"
      (click)="onClosePressed()"
      icon="pi pi-times"
    ></button>
  </taku-form-header>

  <!-- <div class="grid"> -->
  <div class="col-12">
    <div class="grid">
      <div class="col-6">
        <taku-dropdown
          [options]="lookup_stocks"
          fieldName="stockId"
          fieldCaption="Receiving Location"
          [formGroup]="_newPurchaseOrderForm"
          [appendTo]="'body'"
        ></taku-dropdown>
      </div>
      <div class="col-6">
        <div class="p-inputgroup inputgroup-outlined field-searchVendor">
          <span class="p-inputgroup-addon"><i class="material-icons">group</i></span>
          <taku-search-accounts
            id="account_search"
            #accountsSearchBox
            [autoClearOnSelection]="false"
            (onSelectedItemCleared)="clearAccountField()"
            [placeholder]="_searchVendorPlaceholder"
            (itemSelected)="onSearchResAccount($event)"
            (onNewItemClicked)="openNewModelInDialog($event)"
            [accountType]="AccountType.commercial"
            [accountRelationship]="[AccountRelationship.supplier, AccountRelationship.both]"
            [includeHeader]="false"
          >
          </taku-search-accounts>
        </div>
      </div>
    </div>
  </div>

  <footer class="col-12 btn-wrapper">
    <button pButton class="p-button-secondary cancel-btn" label="Cancel" (click)="onClosePressed()"></button>
    <button pButton [disabled]="_newPurchaseOrderForm.invalid" label="Create" (click)="onCreatePressed()"></button>
  </footer>
</div>
<!-- </div> -->

<p-dialog
  [(visible)]="_activeFullDialog"
  [ngSwitch]="_activeFullDialog"
  [contentStyle]="{ maxHeight: '100%' }"
  styleClass="fixedsize-modal"
  [blockScroll]="true"
  [modal]="true"
  [showHeader]="false"
  appendTo="body"
>
  <div *ngSwitchCase="FullSizeDialogName.COMMERCIAL_ACCOUNT" class="new-commercialAccount-panel">
    <taku-commercial-account
      (changedForm)="onNewCommercialAccountCreated($event)"
      [_isDialog]="true"
      [_object]="_activeFullDialogExtra"
      (dialogClosed)="closeFullSizeDialog()"
    ></taku-commercial-account>
  </div>
</p-dialog>
